"use client";

import { motion, useScroll, useSpring } from "framer-motion";

export default function ScrollProgressBar() {
  const { scrollYProgress } = useScroll();
  const progress = useSpring(scrollYProgress, {
    stiffness: 140,
    damping: 28,
    mass: 0.2,
  });

  return (
    <div className="sticky top-[55px] z-40 h-[6px] w-full border-x border-b border-black/20 bg-white dark:border-white/25 dark:bg-neutral-950">
      <motion.div
        className="h-full w-full origin-left bg-green-600 opacity-50 dark:bg-white"
        style={{ scaleX: progress }}
      />
    </div>
  );
}
